import React from "react";
import { useTranslation } from "react-i18next";
import { CommodityDetail } from "../enums/commodityDetail";

interface Props {
  commodityDetail?: CommodityDetail;
}

const ContractSimplifiedHeader = ({ commodityDetail }: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // render
  return (
    <div className="d-none d-lg-block px-3 mb-2 text-muted font-weight-bold mr-5">
      <div className="row no-gutters align-items-end">
        <div className="col">
          <div className="row no-gutters align-items-end">
            <div className="col-lg-5 pr-lg-3 pr-xl-0">
              <div className="row no-gutters align-items-end">
                <div className="col-lg-8 col-xl-7 pr-lg-3 pr-xl-0">
                  <span className="d-xl-none">{tLabels("contractSimplifiedHeader.namedByCustomer.mobile")}</span>
                  <span className="d-none d-xl-inline">{tLabels("contractSimplifiedHeader.namedByCustomer.desktop")}</span>
                </div>
                <div className="col col-lg-4 col-xl-5">
                  <span>
                    {tLabels(
                      commodityDetail === "HeatCustomer"
                        ? "contractSimplifiedHeader.contractNumberHeat"
                        : "contractSimplifiedHeader.contractNumber"
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-xl-4 pr-xl-3 ">
              <span>{tLabels("contractSimplifiedHeader.placeOfDeliveryAddress")}</span>
            </div>
            <div className="col-lg-4 col-xl-3">
              <div className="row no-gutters align-items-end">
                <div className="col-lg-7 col-xl-8">
                  <span>{tLabels("contractSimplifiedHeader.contractDates")}</span>
                </div>
                <div className="col-lg-5 col-xl-4 text-lg-center text-xl-left">
                  <span>{tLabels("contractSimplifiedHeader.contractStatus")}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-auto"></div>
      </div>
    </div>
  );
};

export default ContractSimplifiedHeader;
